import Sidebar from "./Sidebar.component";

export default Sidebar;
